/**
 * Generate data attributes for analytics tracking.
 */
export function attributesAnalytics(props) {
   const attributes = {
      'data-adv-canal': props['adv-canal'],
      'data-adv-cappingdata': props['adv-cappingdata'],
      'data-oevent-action': props['oevent-action'],
      'data-oevent-category': props['oevent-category'],
      'data-oevent-label': props['oevent-label'],
      'data-oevent-other': props['oevent-other'],
      'data-pdb-sc': props['pdb-sc'],
      'data-pdb-idc': props['pdb-idc'],
      'data-pdb-ta': props['pdb-ta'],
      'data-pdb-vi': props['pdb-vi'],
      'data-pdb-zid': props['pdb-zid'],
      'data-pdb-exp': props['pdb-exp'],
   }
   return Object.fromEntries(Object.entries(attributes).filter(([_, value]) => value != null && value !== ''))
}
